import React from 'react';
import styled from 'styled-components';

const Title = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.secondary.main};
  font-size: 0.875rem;
`;

const Value = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.secondary.main};
  margin-left: 0.5rem;
  min-width: 84px;
  text-align: right;
`;

const Row = styled.div`
  text-align: right !important;
`;

const InnerRow = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
`;

const CountryProject = ({ country, projectName }) => (
  <div style={{ marginTop: '4px' }}>
    <Row style={{ marginBottom: '2px' }}>
      <InnerRow>
        <Title>Country:</Title>
        <Value>{country}</Value>
      </InnerRow>
    </Row>
    {projectName && (
      <Row>
        <InnerRow>
          <Title>Project:</Title>
          <Value>{projectName}</Value>
        </InnerRow>
      </Row>
    )}
  </div>
);

export default CountryProject;
